import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
    
      options={{
        strings: [
          "Desarrolladores",
          "Proveedores de hosting",
          "Especialistas en Tecnología",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
